<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year"
                          :data1="graph1.data1" :data2="graph1.data2"
                          :sum1="graph1.sum1" :sum2="graph1.sum2"
                          @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2" :hide-month="true">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph2(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card dateType="yyyy-mm"  :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :list="graph3.list" @change="dateRangeChangeForGraph3" :hide-month="true">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph3(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </daily-comparison-card>
      </vs-col>
    </div>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";

export default {
  name: "GraphDetail05",
  components: {
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    getFieldLabel() {
      return `${this.projectId}` === '2' ? '부서' : '사업장';
    },
    getButtons() {
      return [
        {label: '편성유형', dataType: '편성유형'},
        {label: '부서', dataType: '부서'},
        { label: '사업명', dataType: '사업명' },
      ];
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  data() {
    return {
      summaryKey: ["안전보건예산_항목명", "sum"],
      graph1: {
        title: "전체 안전보건 예산 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 안전보건 예산 현황",
        year: new Date().getFullYear(),
        month: 1, // 항상 1월로 고정
        unit: "천원",
        heads: [{ name: "No." }, { name: "분야명" }, { name: "예산(천원)" }, { name: "전월대비 증감(천원)" }],
        list: [],
        dataType: '편성유형',
      },
      graph3: {
        title: "기간별 안전보건 예산 현황",
        unit: "천원",
        year: new Date().getFullYear(),
        month: 1, // 항상 1월로 고정
        list: [],
        dataType: '편성유형',
      },
      cache: {},
      loading: false,
    };
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL", { project_id: this.projectId });
    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();
  },
  methods: {
    async loadDetailData(currentYear) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }

      const cacheKey = `detail_05_${currentYear}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        try {
          this.$vs.loading();
          this.loading = true;

          const allPosts = [];
          const lastYearDate = new Date(currentYear - 1, 0, 1);
          const currentYearDate = new Date(currentYear, 11, 31);
          const conditions = [
            { key: 'header.year', operator: '>=', value: lastYearDate.format("yyyy") },
            {key: 'header.year', operator: '<=', value: currentYearDate.format("yyyy")}
          ];

          for (let page = 1; page <= 1000; page++) {
            const response = await this.$store.dispatch("board/LOAD_POST_LIST", {
              projectId: this.projectId,
              boardId: 1034,
              page,
              perPage: 1000,
              conditions,
              withMeta: true,
              metaKeys: ['body.safetyBudgetList[%].편성유형', 'body.safetyBudgetList[%].예산', 'body.safetyBudgetList[%].사업명', 'header.year'],
              onlyMeta: true,
            });
            allPosts.push(...response.data);
            if (response.last_page <= page) {
              break;
            }
          }
          console.log(allPosts);

          // 데이터 가공 - 예산 데이터를 연도별, 월별로 구성
          const processedData = this.processData(allPosts, currentYear);
          this.cache[cacheKey] = processedData;

          return processedData;
        } catch (e) {
          this.$vs.notify({title: "Error", text: "데이터를 불러오는데 실패했습니다.", color: "danger"});
        } finally {
          this.loading = false;
          this.$vs.loading.close();
        }
      }
    },

    processData(posts, currentYear) {
      const prevYear = currentYear - 1;

      // 결과 데이터 구조 초기화
      const result = {
        monthlyBudget: {
          [currentYear]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 첫 번째 값은 총합, 나머지는 월별 값
          [prevYear]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        dataByType: {
          '편성유형': {},
          '부서': {},
          '사업명': {}
        }
      };

      // 연도별 월별 데이터 구조 초기화
      for (const year of [currentYear, prevYear]) {
        for (const type of ['편성유형', '부서', '사업명']) {
          result.dataByType[type][year] = {};
          for (let month = 1; month <= 12; month++) {
            result.dataByType[type][year][month] = [];
          }
        }
      }

      // 데이터 처리
      for (const post of posts) {
        const postYear = post.postContents && post.postContents.header ? parseInt(post.postContents.header.year) : null;

        if (!postYear || (postYear !== currentYear && postYear !== prevYear)) continue;

        let totalBudget = 0;
        const budgets = {};

        // 편성유형별, 사업명별 예산 합계
        if (post.postContents && post.postContents.body && post.postContents.body.safetyBudgetList) {
          for (const budget of post.postContents.body.safetyBudgetList) {
            const budgetAmount = Number(budget.예산 || 0);
            totalBudget += budgetAmount;

            // 편성유형별 집계
            const type = budget.편성유형 || '기타';
            if (!budgets['편성유형']) budgets['편성유형'] = {};
            if (!budgets['편성유형'][type]) budgets['편성유형'][type] = 0;
            budgets['편성유형'][type] += budgetAmount;

            // 사업명별 집계
            const project = budget.사업명 || '기타';
            if (!budgets['사업명']) budgets['사업명'] = {};
            if (!budgets['사업명'][project]) budgets['사업명'][project] = 0;
            budgets['사업명'][project] += budgetAmount;
          }
        }

        // 부서(field_name)별 집계
        const department = post.field && post.field.field_name ? post.field.field_name : '기타';
        if (!budgets['부서']) budgets['부서'] = {};
        if (!budgets['부서'][department]) budgets['부서'][department] = 0;
        budgets['부서'][department] += totalBudget;

        // 월별 예산 업데이트 (모든 월에 같은 값 설정)
        result.monthlyBudget[postYear][0] += totalBudget; // 총합 업데이트
        for (let month = 1; month <= 12; month++) {
          result.monthlyBudget[postYear][month] += totalBudget; // 모든 월에 동일한 총 예산 할당
        }

        // dataByType 업데이트
        for (const type of ['편성유형', '부서', '사업명']) {
          if (!budgets[type]) continue;

          for (const [key, value] of Object.entries(budgets[type])) {
            for (let month = 1; month <= 12; month++) {
              // 각 월마다 키별 예산 설정
              const existingItem = result.dataByType[type][postYear][month].find(item => item.label === key);
              if (existingItem) {
                existingItem.budget += value; // 월별 동일 금액 할당 (12로 나누지 않음)
              } else {
                result.dataByType[type][postYear][month].push({
                  label: key,
                  budget: value, // 월별 동일 금액 할당 (12로 나누지 않음)
                  company_id: post.company_id
                });
              }
            }
          }
        }
      }

      return result;
    },

    // 그래프 1
    async loadGraph1() {
      const yyyy = this.graph1.year;
      const data = await this.loadDetailData(yyyy);

      this.graph1.data1 = data.monthlyBudget[yyyy].slice(1); // 첫번째 값(총합)을 제외한 월별 데이터
      this.graph1.data2 = data.monthlyBudget[yyyy - 1].slice(1);

      // 총합 포맷팅
      this.graph1.sum1 = new Intl.NumberFormat().format(data.monthlyBudget[yyyy][0]);
      this.graph1.sum2 = new Intl.NumberFormat().format(data.monthlyBudget[yyyy - 1][0]);
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 2024.05.02
    // https://app.clickup.com/t/86ep8969h
    // 경남도청의 경우, 조회한 사용자의 소속을 표시한다.
    getGsndLabel(item) {
      const memberInfo = this.$store.state.member.memberInfo;
      let label = item.label;
      if (label === '경남도청' && parseInt(item.company_id) === parseInt(memberInfo.company_id) && memberInfo.section) {
        label = memberInfo.section;
      }
      return label
    },

    // 그래프 2
    async loadGraph2() {
      const yyyy = this.graph2.year;
      const data = await this.loadDetailData(yyyy);

      const currentYear = yyyy;
      const currentMonth = 1; // 항상 1월로 고정
      const prevYear = currentYear - 1;
      const prevMonth = 12; // 이전 연도의 12월과 비교

      const currentData = data.dataByType[this.graph2.dataType][currentYear][currentMonth];
      const prevData = data.dataByType[this.graph2.dataType][prevYear][prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.budget - prevRow.budget : row.budget;
        list.push({
          no,
          name: this.getGsndLabel(row),
          value: `${new Intl.NumberFormat().format(row.budget)}`,
          valueRaw: row.budget,
          gap,
        });
        no += 1;
      }

      // list를 value 기준으로 내림차순 정렬한다
      list.sort((a, b) => b.valueRaw - a.valueRaw);

      this.graph2.list = list;
    },
    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.value;
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: `${new Intl.NumberFormat().format(value.gap)}` };
      }
      return "";
    },
    dateChangeForGraph2(year) {
      this.graph2.year = year;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType, label) {
      this.graph2.heads[1].name = label;
      if (this.projectId) {
        this.graph2.dataType = dataType;
        this.loadGraph2();
      }
    },

    // 그래프 3
    async loadGraph3() {
      const yyyy = this.graph3.year;
      const data = await this.loadDetailData(yyyy);

      const currentMonth = 1; // 항상 1월로 고정
      const currentData = data.dataByType[this.graph3.dataType][yyyy][currentMonth];

      const list = [];

      for (const row of currentData) {
        list.push({
          label: this.getGsndLabel(row),
          value: row.budget,
        });
      }

      // list를 value 값 기준으로 내림차순 정렬한다
      list.sort((a, b) => b.value - a.value);

      this.graph3.list = list;
    },
    dateRangeChangeForGraph3(year) {
      this.graph3.year = year;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType) {
      if (this.projectId) {
        this.graph3.dataType = dataType;
        this.loadGraph3();
      }
    },
  },
};
</script>

<style scoped></style>
